module.exports = __webpack_public_path__ + "static/media/16_l_paporotnik_9.9_70.28.af549fd5.png";